import { render, staticRenderFns } from "./applyVolunteer.vue?vue&type=template&id=08fbfa93&scoped=true"
import script from "./applyVolunteer.vue?vue&type=script&lang=js"
export * from "./applyVolunteer.vue?vue&type=script&lang=js"
import style0 from "./applyVolunteer.vue?vue&type=style&index=0&id=08fbfa93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fbfa93",
  null
  
)

export default component.exports